import { render, staticRenderFns } from "./UserReviewWarningModal.vue?vue&type=template&id=160eb85b&"
import script from "./UserReviewWarningModal.vue?vue&type=script&lang=js&"
export * from "./UserReviewWarningModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports